import {
  CButton,
  CCard,
  CCardBody,
  CCardTitle,
  CCol,
  CDataTable,
  CInput,
  CLabel,
  CRow,
} from "@coreui/react";
import React, { useState } from "react";
import { formatDate } from "src/shared/Format/dateFormat";
import { apiCall } from "src/_apiConfig/apiCall";

const MISReport = () => {
  const [dateFrom, setdateFrom] = useState("");
  const [dateTo, setdateTo] = useState("");
  const [paymentsDetails, setpaymentsDetails] = useState([]);
  const getPaymentsDetails = async () => {
    if (dateFrom && dateTo) {
      const header = new Headers();
      const response = await apiCall(
        `LotDetails/getpaymentsreport?$filter=paymentSuccessDate gt ${dateFrom} and paymentSuccessDate lt ${dateTo}`,
        "GET",
        header,
        null
      );
      const jsonobj = await response.json();
      if (response.status === 200) {
        setpaymentsDetails(jsonobj);
      }
    }
  };

  const paymentFields = [
    {
      key: "lotNO",
      label: <div>Lot No.</div>,
    },
    {
      key: "tenderNo",
      label: <div>Tender No</div>,
    },
    {
      key: "collectionSeassion",
      label: <div>Collection Season</div>,
    },
    {
      key: "email",
      label: <div>User</div>,
    },
    {
      key: "paymentSuccessDate",
      label: <div>Payment Date</div>,
    },
    {
      key: "amount",
      label: <div>Amount</div>,
    },
    {
      key: "type",
      label: <div>Type</div>,
    },
  ];

  return (
    <>
      <CCard>
        <CCardBody>
          <h3 className="">Generate MIS Report</h3>
          <hr />
          <CRow>
            <CCol xl={3}>
              <CLabel>Date From</CLabel>
              <CInput
                type="date"
                onChange={(e) => setdateFrom(e.target.value)}
              />
            </CCol>
            <CCol xl={3}>
              <CLabel>Date To</CLabel>
              <CInput type="date" onChange={(e) => setdateTo(e.target.value)} />
            </CCol>

            <CCol xl={3}>
              <CButton
                onClick={getPaymentsDetails}
                style={{ marginTop: "1.8rem" }}
                color="primary"
              >
                Generate
              </CButton>

              <CButton
                style={{ marginTop: "1.8rem" }}
                className="ml-2"
                color="success"
                onClick={() => window.print()}
              >
                Print
              </CButton>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>

      {paymentsDetails.length > 0 && (
        <CCard textColor="success" className="mt-3  border-success">
          <CCardTitle className="text-center pt-2">MIS Report</CCardTitle>
          <CDataTable
            items={paymentsDetails}
            fields={paymentFields}
            addTableClasses="table "
            responsive
            border
            scopedSlots={{
              type: (item, index) => {
                return (
                  <td className="py-2">
                    <span>
                      {item.transactionType === 0 && "Lot Payment"}
                      {item.transactionType === 1 && "Adjustment"}
                      {item.transactionType === 2 && "Transfer Fee"} |&nbsp;
                      {item.type === 1 && "Offline"}
                      {item.type === 2 && "Online"}
                    </span>
                  </td>
                );
              },
              paymentSuccessDate: (item, index) => {
                return (
                  <td className="py-2">
                    <span>
                      {item.paymentSuccessDate &&
                        formatDate(item.paymentSuccessDate)}
                    </span>
                  </td>
                );
              },
              responseMessage: (item, index) => {
                return (
                  <td className="py-2">
                    <span>{item.responseMessage ?? " "}</span>
                  </td>
                );
              },
              responseString: (item, index) => {
                return (
                  <td className="py-2">
                    <span>{item.responseString ?? " "}</span>
                  </td>
                );
              },
            }}
          />
        </CCard>
      )}
    </>
  );
};

export default MISReport;
